import { MutableRefObject, useEffect, useState } from 'react';

export const useWindowScrollPositions = (
  ref?: MutableRefObject<HTMLDivElement | null>
) => {
  const [scrollPosition, setPosition] = useState({ scrollX: 0, scrollY: 0 });

  useEffect(() => {
    function updatePosition(event: Event) {
      const element = event.target as Element;

      if (element)
        setPosition({
          scrollX: element?.scrollLeft,
          scrollY: element?.scrollTop,
        });
    }

    const element = ref?.current || window;

    element.addEventListener('scroll', updatePosition);

    return () => element.removeEventListener('scroll', updatePosition);
  }, [ref]);

  return scrollPosition;
};
